// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BottomFixedContent_wrapper__vjVRg"};